import { Chip } from '@mui/material';
import PropTypes from 'prop-types';

const InputLabel = ({ label, head = false, sx }) => {
	return (
		<Chip
			label={label}
			variant="outlined"
			sx={{
				width: '100%',
				mb: '24px',
				justifyContent: 'start',
				borderColor: '#e2ebf7',
				fontWeight: head ? 600 : 400,
				background: head ? '#edf7ff' : 'transparent',
				...sx,
			}}
		/>
	);
};

InputLabel.propTypes = {
	label: PropTypes.string,
	head: PropTypes.bool,
};

export default InputLabel;
